import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useTaxLegalServicesLogic } from './hooks/useTaxLegalServicesLogic';
import { TaxLegalServicesForm } from './TaxLegalServicesForm';

export const EddTaxLegalServices = () => {
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useTaxLegalServicesLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={tCommon('sectionTitles.businessActivity')}
        headingContainerCustomStyle='!mb-[16px]'>
        <TaxLegalServicesForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
